// extracted by mini-css-extract-plugin
export default {"sectionHeader":"Checkout_sectionHeader__d75W9","checkout":"Checkout_checkout__fQ3my"};